export * from "../ploom/device-laptop";
